import {config} from '../../config'

console.log('--baseURL 222',config.baseURL);

// const URL = '/wjgl/tempdownload/'
// const URL = '/ceshi/wjgl/tempdownload/'
const URL = config.baseURL + '/wjgl/tempdownload/'
export default {
    /* 保全申请书 */
    BQSQS: URL + '4',
    /* 操作手册 */
    CZSC: URL + '3',
    /* 样例文件 */
    YLWJ: URL + '2',
    /* 授权委托书 */
    SQWTS: URL + '1',
    /* 模板下载 */
    MB: '/wsbq/ssbq/api/wjgl/tempdownload/',
    /* 保单 */
    BD: '/wsbq/commonapi/api/policy/zdz/download',
    /* 保函 */
    BH: '/wsbq/commonapi/api/policy/zdz/download',
    /* 材料 */
    CL: '/wsbq/ssbq/api/sccls/clxz',
    CZZN: ''
}
